@if (isWidgetVisible()) {
  <div
    (click)="onCloseClick()"
    class="search-categories-mobile-panel-overlay"
  ></div>

  <div
    [ngClass]="animationClass()"
    class="search-categories-mobile-panel"
  >
    <div class="search-categories-mobile-panel__header">
      @if (currentPage() === SearchWidgetFiltersPageEnum.CARE_SERVICE_UNITS) {
        <button
          (click)="navigateBack()"
          aria-label="Tillbaka"
          class="icon-button navigate_back"
          type="button"
        >
          <app-ui-icon color="var(--grey-5)" name="chevron_back" size="md"></app-ui-icon>
        </button>
      }

      <div class="search-categories-mobile-panel__top-container">
        <div class="search-categories-mobile-panel__title">Kategorier</div>
      </div>
      <button
        (click)="onCloseClick()"
        aria-label="Stäng"
        class="icon-button close"
        type="button"
      >
        <app-ui-icon color="var(--grey-5)" name="close" size="md"></app-ui-icon>
      </button>
    </div>
    <app-search-categories-v3 (currentPageUpdated)="onCurrentPageUpdated($event)"></app-search-categories-v3>
  </div>
}
